import Reportings from '../index'
import ReportItem from '../report'
import { isProd } from '@/utils/helper'

export default [
  {
    name: 'Reportings',
    component: Reportings,
    path: '/reportings',
    /* beforeEnter kontrolü tekrar eklenecek. Hotfix için silindi.
    beforeEnter: (to, from, next) => {
      if (!from.name && !isProd) {
        const externalUrl = window.VUE_APP_SIMPRA_REPORTS_URL || process.env.VUE_APP_SIMPRA_REPORTS_URL
        window.location.href = externalUrl;
      }
    }, */
    meta: {
      slug: 'reports',
      main_menu: true,
      page: 'reports',
      permissionKey: 'ReportsMenu'
    }
  },
  {
    name: 'ReportItem',
    path: '/reportings/:id/:name',
    component: ReportItem,
    meta: {
      page: 'reports',
      breadcrumb: [
        {
          name: 'reports',
          to: 'Reportings'
        },
        {
          withParams: true,
          param: 'name',
          to: null
        }
      ]
    }
  }
]

